import { Visibility, VisibilityOff } from "@mui/icons-material"
import { Chip } from "@mui/material"

type ToggleNodeChipsProps = {
  nodeLabels: string[]
  selectedNodeLabels: string[]
  onToggle: (nodeLabel: string) => void
}

const ToggleNodeChips = (props: ToggleNodeChipsProps) => {
  return (
    <>
      {props.nodeLabels.map((nodeLabel) => {
        const isSelected = props.selectedNodeLabels.includes(nodeLabel)

        return (
          <Chip
            color="primary"
            key={nodeLabel}
            sx={{
              "&.MuiChip-root": {
                borderRadius: "4px",
                backgroundColor: isSelected ? "primary" : "primary.100",
              },
            }}
            label={nodeLabel}
            onClick={() => props.onToggle(nodeLabel)}
            icon={isSelected ? <Visibility /> : <VisibilityOff />}
          />
        )
      })}
    </>
  )
}

export default ToggleNodeChips
